import { ReactElement, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Layout, Menu, Button } from "antd";
import { UploadOutlined, UserOutlined, DownloadOutlined } from '@ant-design/icons';
import "../assets/css/index.css";
import api from "../redux/api/axiosInstance";

export function ShopSideBar(props:any): ReactElement {
   
const { t } = useTranslation();
const { SubMenu } = Menu;

const { getCategoryPro } = props;

const { Header, Content, Footer, Sider } = Layout;
const [category, setCategory] = useState<any[]>([]);
const history = useHistory();

const getCategory = ()=>{
    api.get("getCategory")
    .then(res => {
        setCategory(res.data.categoryData);
    })
    .catch(e => {
        console.log(e);
    })
}

useEffect(() => {
    getCategory();
}, []);

const chooseCategory = (id : any) => {
    // console.log(id);
    history.push(`/shop/category/${id}`);
}

return (
        <Menu 
            mode="inline"
        >
            {category && category.map(({name, catID, parent}) => (
                parent === 0 &&
                <SubMenu key={catID} title={name}>
                {
                    category.map((cats)=>(
                        cats.parent === catID && 
                        <Menu.Item onClick = {()=>getCategoryPro(cats.catID)}>{cats.name}</Menu.Item>
                    ))
                }
                </SubMenu>
            ))}
        </Menu>
  );
}
